(function ($) {
    //$.fn.initializeFancybox = function (options) {
    $.fn.initializeFancybox = function () {
		
	};

    //Initialize Fancybox
    if($('[data-fancybox]').length){
        $('[data-fancybox]').fancybox({
			
		});
	}
    
})(jQuery);


// WEBPACK FOOTER //
// ./scripts/modules/fancybox.js